export class User {
  id: number;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  token: string;
}


export class UserDetailModel {
  id: number;
  user_id: number;
  geographical_id: number;
  geography_name: string;
  channel_type: string;
  channel_id: number;
  channel_name: string;
  sub_channel: string;
  state_code: number;
  state_name: string;
  state_year: string;
  ro_code: string;
  ro_name: string;
  ro_email: string;
  user_detail_name: string;
  subbranch_id: number;
  salestax_regno: number;
  class_code: number;
  group_id: number;
  license_no: number;
  outlet_img1: string;
  outlet_img2: string;
  profile_pic: string;
  address: string;
  lane: string;
  landmark: string;
  area: string;
  city: string;
  pincode: string;
  contact_no: string;
  business_from_time: string;
  business_to_time: string;
  cover_def: string;
  chiller_placed: string;
  signage_placed: string;
  stock_space: string;
  waiter_no: number;
  owner_name: string;
  owner_contact_no: string;
  manager_name: string;
  manager_contact_no: string;
  manager_email: string;
  location_id: string;
  status: number;
  created_date: string;
  updated_date: string;
  tse_user_id: string;
  document_no: string;
  document_file: string;
  gender: string;
  date_of_birth: string;
  emp_code: string;
  latitude: string;
  longitude: string;
  anniversary_date: string;
  region_id: string;
  user_role_id: number;
  user_data : UserModel;
  isEdit: boolean;
  username: string;
  state : any;
}

export class UserModel{
  created_date:  string;
  default_lang:  string;
  generated_super:  string;
  id: number;
  is_verified:  string;
  last_login_at:  string;
  last_login_ip:  string;
  password_hash:  string;
  points:  string;
  program_id: number;
  status: number;
  status_label:  string;
  supervisor:  string;
  supervisor_name:  string;
  supervisor_number:  string;
  updated_date:  string;
  user_role_id: number;
  user_role_name:  string;
  username:  string;
  wallet: string;
}

export class UserMobileUpdateModel {
  user_id : number;
  mobile : string;
}


export class UpdateMobileModel {
  userexcelupload : number;
  userupdate : UserMobileUpdateModel[];
}
